// src/components/Footer.tsx
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer
      style={{
        color: 'var(--text-muted)',
        textAlign: 'center',
        padding: '1rem',
        fontSize: '0.9rem',
      }}
    >
      <div
        style={{
          borderTop: '1px solid var(--info-bar)',
          marginBottom: '0.5rem',
          width: '100%',
        }}
      ></div>
      <div style={{ marginTop: '0.5rem' }}>
        © 2026 Digital Relics. "Reword Game" is a trademark of Digital Relics. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;